export const resourcePoolTag = 'resourcePool:';
